// extracted by mini-css-extract-plugin
module.exports = {"toggleButton":"styles_toggleButton__rBs1b","label":"styles_label__KbEPz","icon":"styles_icon__3En4c"};